import { deviceDetector } from '../utils/helper';

export const updateSpot = ({ map, lat, lon }) => {
  const doUpdateGoogleMaps = () => {
    map.panTo({ lat: parseFloat(lat, 10), lng: parseFloat(lon, 10) });
  };
  const didLoad = map && !!map.mapUrl;

  if (didLoad) {
    setTimeout(doUpdateGoogleMaps, 200);
  }
};

export const openDeviceMap = address => {
  const url = deviceDetector.isIOS()
    ? `http://maps.apple.com/?q=${address}`
    : `http://www.google.com/maps/dir//${address}`;
  window.location.href = url;
};
